<template>
  <AuthWrongBase>
    Lo sentimos, pero en estos momentos no puedes acceder a la aplicación
  </AuthWrongBase>
</template>

<script>
import AuthWrongBase from '@/components/AuthWrongBase'

export default {
  components: { AuthWrongBase },
}
</script>
